var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17631_24218)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62902 2.6585C7.62904 1.692 8.41255 0.908489 9.37904 0.908478L11.129 0.908455C12.0955 0.908447 12.879 1.69194 12.879 2.65844L12.879 2.71153C13.5693 2.71157 14.1289 3.27119 14.1289 3.96151L14.1289 9.96151C14.1288 10.6519 13.5692 11.2115 12.8788 11.2115L10.8798 11.2116L10.8792 6.64761C10.879 5.12883 9.64766 3.89742 8.12888 3.89717L6.13057 3.89685C6.16427 3.23659 6.7103 2.7116 7.37894 2.71159L7.62902 2.71159L7.62902 2.6585ZM9.37903 2.40848C9.24096 2.40848 9.12903 2.52041 9.12902 2.65848L9.12902 3.15848L11.379 3.15845L11.379 2.65845C11.379 2.52038 11.2671 2.40846 11.129 2.40846L9.37903 2.40848ZM1.37922 6.64609C1.37914 5.95574 1.93871 5.39618 2.62907 5.39629L8.12907 5.39717C8.81942 5.39728 9.37914 5.95702 9.37922 6.64737L9.38014 13.8974C9.38022 14.5877 8.82065 15.1473 8.1303 15.1472L2.6303 15.1463C1.93994 15.1462 1.38023 14.5865 1.38014 13.8961L1.37922 6.64609ZM3.62891 11.1457C3.2147 11.1457 2.87891 11.4815 2.87891 11.8957C2.87891 12.3099 3.2147 12.6457 3.62891 12.6457L7.12891 12.6457C7.54313 12.6457 7.87891 12.3099 7.87891 11.8957C7.87891 11.4815 7.54313 11.1457 7.12891 11.1457L3.62891 11.1457ZM2.87891 9.1457C2.87891 8.73149 3.2147 8.3957 3.62891 8.3957L7.12891 8.3957C7.54313 8.3957 7.87891 8.73149 7.87891 9.1457C7.87891 9.55991 7.54313 9.8957 7.12891 9.8957L3.62891 9.8957C3.2147 9.8957 2.87891 9.55991 2.87891 9.1457Z",
    fill: "#BE5400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17631_24218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentList);
export default __webpack_public_path__ + "static/media/document-list.75a62f1cb6ce8f8cc9e82629ed7bd5fa.svg";
export { ForwardRef as ReactComponent };